"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconeDeStatus = void 0;
var rebass_1 = require("rebass");
var react_1 = __importDefault(require("react"));
var tema_1 = require("../../tema");
var react_feather_1 = require("react-feather");
var StatusDoInput_1 = require("./StatusDoInput");
var IconeDeStatus = function (_a) {
  var _b = _a.visivel,
    visivel = _b === void 0 ? false : _b,
    status = _a.status;
  return react_1.default.createElement(rebass_1.Box, {
    sx: {
      display: visivel ? "flex" : "none",
      color: "inherit",
      svg: {
        size: 24
      }
    },
    className: "icone-de-status"
  }, status === StatusDoInput_1.StatusDoInput.SUCESSO && react_1.default.createElement(react_feather_1.CheckCircle, {
    color: tema_1.colors.positivo
  }), status === StatusDoInput_1.StatusDoInput.ERRO && react_1.default.createElement(react_feather_1.AlertCircle, {
    color: tema_1.colors.negativo
  }));
};
exports.IconeDeStatus = IconeDeStatus;